export default {
  en: {
    placeholder: 'Write a message...',
    filesAttached: 'Attach files | {n} file attached | {n} files attached',
    send: 'Send',
    failed: 'Comment failed to send. Try again',
    inputHelp: 'Visible to client & supplier',
    inputHelpExtra: 'Visible to you and {orgName}',
    validation: {
      empty: 'Enter a message',
      attachmentsUploading: 'Wait for your attachments to finish uploading',
    },
  },
};
